<!--<v-page-message class="&#45;&#45;add-wrap-margin"-->
                <!--[headerText]="'header text'"-->
                <!--[contentText]="'Na podany adres e-mail został wysłany mail z linkiem aktywacyjnym. Prosimy o dokończenie rejestracji, klikając w link znajdujący się w mailu. Link ważny jest 48h'"-->
                <!--[buttonText]="'Push The Button'"-->
                <!--[buttonUrl]="'http://www.test.pl/'"-->
                <!--[nameIcon]="'APPLICATION'"-->
<!--&gt;-->
<!--</v-page-message>-->

<v-common-modal></v-common-modal>
